import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <a class="skip-link" href="#conteudo">Pular para o conteúdo</a>
    <router-outlet />
  `
})
export class AppComponent {
  private readonly router = inject(Router);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      window.setTimeout(() => {
        document.querySelector<HTMLElement>('#conteudo')?.focus({ preventScroll: true });
      });
    });
  }
}
